import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class Communication extends Ability {
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;
  @service declare authz: AuthzService;

  // TODO: Incorporate FC instead here
  get canVisit(): boolean {
    return this.canSeeFeatures && this.canReadCommunications;
  }

  get canVisitMessages(): boolean {
    return this.canVisit;
  }

  get canSeeFeatures(): boolean {
    return !!this.state.features?.canAccessEmergencyNotifications;
  }

  get canReadCommunications(): boolean {
    const permissions = [
      Permission.COMMUNICATIONS_ANNOUNCEMENT_READ,
      Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_READ,
      Permission.COMMUNICATIONS_SETTING_READ,
    ];

    return this.authz.hasAnyPermissionAtCurrentLocation(permissions);
  }

  get canAccessEmployeesEmergencyFeaturesAtLocation(): boolean {
    return !!this.state.features?.canAccessEmergencyNotificationsEmployeesAtLocation;
  }

  get canAccessEmployeesEmergencyFeatures(): boolean {
    return !!this.state.features?.canAccessEmergencyNotificationsEmployees;
  }

  get canAccessVisitorsEmergencyFeatures(): boolean {
    return !!this.state.features?.canAccessEmergencyNotificationsVisitors;
  }

  get canManageAnnouncements(): boolean {
    const permissions = [
      Permission.COMMUNICATIONS_ANNOUNCEMENT_CREATE,
      Permission.COMMUNICATIONS_ANNOUNCEMENT_READ,
      Permission.COMMUNICATIONS_ANNOUNCEMENT_UPDATE,
      Permission.COMMUNICATIONS_ANNOUNCEMENT_DELETE,
    ];

    return this.authz.hasAllPermissionsAtCurrentLocation(permissions);
  }

  get canManageAnnouncementTemplates(): boolean {
    const permissions = [
      Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_CREATE,
      Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_READ,
      Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_UPDATE,
      Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_DELETE,
    ];

    return this.authz.hasAllPermissionsAtCurrentLocation(permissions);
  }

  get canManageSettings(): boolean {
    const permissions = [
      Permission.COMMUNICATIONS_SETTING_CREATE,
      Permission.COMMUNICATIONS_SETTING_READ,
      Permission.COMMUNICATIONS_SETTING_UPDATE,
      Permission.COMMUNICATIONS_SETTING_DELETE,
    ];

    return this.authz.hasAllPermissionsAtCurrentLocation(permissions);
  }

  get canExportOnSiteData(): boolean {
    return this.canAccessEmployeesEmergencyFeatures || this.canAccessVisitorsEmergencyFeatures;
  }
}
